import { pixelToRem } from '../../../theme/pxToRem';
import { SiteCoreTypographyData } from './typography.type';

type StyleProperties = Pick<
  React.CSSProperties,
  'fontSize' | 'color' | 'fontWeight' | 'fontFamily'
>;
type AllowedProperties = keyof StyleProperties;
type ReturnValue = {
  styles: StyleProperties;
  isApplicableToRichText: boolean;
  responsiveFontSize: {
    tablet: string;
    mobile: string;
  };
};

function generateTypographyStyles(
  data: SiteCoreTypographyData,
  fallBack: SiteCoreTypographyData
): ReturnValue {
  const fontFace = ' ' + (data?.fontFace?.value || fallBack.fontFace?.value || '');
  const styles = {
    color: data?.fontColor?.value || fallBack.fontColor.value,
    fontSize: pixelToRem(data?.fontSize?.value || fallBack.fontSize.value),
    fontWeight: parseInt(data?.fontWeight?.value || fallBack.fontWeight.value),
    fontFamily:
      (data?.fontFamilyType?.name || fallBack.fontFamilyType.name)
        .split(',')
        .filter((x) => x)
        .join(fontFace + ', ') + fontFace,
  };

  const response: ReturnValue = {
    styles,
    isApplicableToRichText: !!data?.isApplicableToRichText?.value,
    responsiveFontSize: {
      mobile: data?.mobileFontSize?.value || fallBack.mobileFontSize?.value,
      tablet: data?.tabletFontSize?.value || fallBack.tabletFontSize?.value,
    },
  };

  return response;
}

function getRichTextTypographyStyles(styles: StyleProperties) {
  const filters: AllowedProperties[] = ['fontFamily', 'fontSize', 'fontWeight', 'color'];

  const filteredStyles =
    filters?.reduce<StyleProperties>((r, i) => {
      return {
        ...r,
        [i]: styles[i],
      };
    }, {}) || {};

  return filteredStyles;
}

export { generateTypographyStyles, getRichTextTypographyStyles };
export type { AllowedProperties };
